import HelloBarCookie from './HelloBarCookie';
import { showHellobar, addScrollWatcher, addTimeoutWatcher } from './util';

async function init() {
	if (typeof window.hbConfig === 'undefined') {
		return;
	}

	const helloBarCookie = new HelloBarCookie(
		'ignore_hellobar_' + window.hbConfig.id + '_' + window.hbConfig.modTime
	);

	if (helloBarCookie.get() !== null) {
		return;
	}

	// basic class wrapper at a high level for targeting
	document.body.classList.add('hellobar-available');

	// get the hellobar info and markup
	try {
		const res = await fetch(apiSettings.hellobar.site_url_base + 'wp-json/hellobar/get/' + window.hbConfig.id, {
			method: 'GET',
			cache: 'no-cache'
		});

		if (!res.ok) {
			throw new Error('Unable to fetch hello bar markup for id ' + window.hbConfig.id);
		}

		const data = await res.json();

		if (data.html) {
			document.body.insertAdjacentHTML('beforeend', data.html);

			// add close handler
			var closeEl = document.querySelector('.hellobar__close');

			if (closeEl) {
				closeEl.addEventListener('click', function () {
					showHellobar(false, helloBarCookie);
				});
			}

			// add trigger handler
			switch (data.trigger.type) {
				case 'scroll':
					addScrollWatcher(parseInt(data.trigger.value, 10));
					break;

				case 'timeout':
					addTimeoutWatcher(parseInt(data.trigger.value, 10));
					break;

				default:
					showHellobar(true, helloBarCookie);
					break;
			}
		}
	} catch (err) {
		console.error(err);
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		init();
	});
} else {
	init();
}
